/**
 * Ingredient Strip — Scroll-triggered entrance animation
 *
 * Adds .is-visible to the ingredient multicolumn section when it
 * enters the viewport. CSS in artemis-custom.css handles the
 * staggered fade-in + subtle idle float.
 */
(function () {
  var section = document.getElementById('shopify-section-multicolumn_ingredients');
  if (!section) return;

  section.classList.add('ingredient-animate');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    section.classList.add('is-visible');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  observer.observe(section);
})();
